import { FC, useEffect, useState } from 'react';

import { Flex, Space, Spin } from 'antd';

import { IconDownload, IconArrowDown, IconArrowUp } from '@assets';
import {
  isPreviewPending,
  isPreviewReady,
  isRenderableImageMimeType,
  PreviewableFile,
  resolvePreviewSrc,
} from '@utils';

import * as S from './styled';

type UploadFileProps = {
  name?: string;
  type?: string;
  url?: string;
  previewUrl?: string;
  previewStatus?: string;
};

const UploadFile: FC<UploadFileProps> = ({
  url,
  type,
  name,
  previewUrl,
  previewStatus,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const previewFile: PreviewableFile = { url, previewUrl, previewStatus };

  // A ready HEIC→JPEG preview counts as an image regardless of the original MIME.
  const isTypeImage =
    isRenderableImageMimeType(type) || isPreviewReady(previewFile);

  const isTypePDF = !isTypeImage && type?.includes('pdf');

  const previewSrc = resolvePreviewSrc(previewFile);
  const [previewError, setPreviewError] = useState(false);
  useEffect(() => setPreviewError(false), [previewSrc]);
  const showImage = isTypeImage && !!previewSrc && !previewError;

  return (
    <Flex vertical>
      <S.Container>
        <Space size={6} align="center">
          <S.Label>1 file uploaded</S.Label>

          <S.Download>
            <a href={url} target="_blank" rel="noreferrer" aria-label="Download">
              <IconDownload />
            </a>
          </S.Download>
        </Space>

        <S.Preview>
          <S.PreviewLink
            onClick={() => setIsPreviewOpen((prevState) => !prevState)}
          >
            Preview {isPreviewOpen ? <IconArrowUp /> : <IconArrowDown />}
          </S.PreviewLink>

          {isPreviewOpen && (
            <S.PreviewContent>
              {/* A pending HEIC is not renderable and not ready, so gate the
                  spinner directly on the pending state, not on isTypeImage. */}
              {isPreviewPending(previewFile) && <Spin />}

              {showImage && (
                <img
                  src={previewSrc}
                  alt={name}
                  onError={() => setPreviewError(true)}
                />
              )}

              {isTypePDF && <iframe src={url} title={name} />}
            </S.PreviewContent>
          )}
        </S.Preview>
      </S.Container>
    </Flex>
  );
};

export default UploadFile;
